import React from "react";
import { Box, Typography, Stack, IconButton } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer: React.FC = () => {
  return (
    <Box sx={{ backgroundColor: "#000000", color: "#FFFFFF", padding: "40px 20px" }}>
      <Box
        sx={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          gap: 4,
        }}
      >
        {/* Services Section */}
        <Box flex="1">
          <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: "16px" }}>
            Services
          </Typography>
          <Stack spacing={1}>
            {[
              { label: "IEPF Claim", link: "/iepf_claim" },
              { label: "ROC Services", link: "/roc_services" },
              { label: "Duplicate Issue of Shares", link: "/duplicate_shares" },
              { label: "Transmission of Shares", link: "/transmission_shares" },
              { label: "Unclaimed Mutual Funds", link: "/unclaimed_mutual_fund" },
              { label: "Unclaimed Provident Funds", link: "/unclaimed_provident_fund" },
            ].map((service) => (
              <Typography
                component="a"
                href={service.link}
                key={service.label}
                variant="body2"
                sx={{
                  color: "#B5B5B5",
                  textDecoration: "none",
                  "&:hover": { color: "#8BC34A" },
                }}
              >
                {service.label}
              </Typography>
            ))}
          </Stack>
        </Box>

        {/* Quick Links Section */}
        <Box flex="1">
          <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: "16px" }}>
            Quick Links
          </Typography>
          <Stack spacing={1}>
            {[
              { label: "About Us", link: "/about-us" },
              { label: "Become Associate", link: "/become-associate" },
              { label: "Privacy Policy", link: "/privacy-policy" },
              { label: "Terms and Conditions", link: "/terms-and-conditions" },
            ].map((page) => (
              <Typography
                component="a"
                href={page.link}
                key={page.label}
                variant="body2"
                sx={{
                  color: "#B5B5B5",
                  textDecoration: "none",
                  "&:hover": { color: "#8BC34A" },
                }}
              >
                {page.label}
              </Typography>
            ))}
          </Stack>
        </Box>

        {/* Contact Us Section */}
        <Box flex="1">
          <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: "16px" }}>
            Contact Us
          </Typography>
          <Stack spacing={1}>
            <Typography variant="body2" sx={{ color: "#B5B5B5" }}>
              Address: 1574/31, Naiwala, Karolbagh, New Delhi, India
            </Typography>
            <Typography variant="body2" sx={{ color: "#B5B5B5" }}>
              Phone: +91 9318469513
            </Typography>
            <Typography variant="body2" sx={{ color: "#B5B5B5" }}>
              Email: getmyshares1@gmail.com
            </Typography>
          </Stack>
        </Box>

        {/* Follow Us Section */}
        <Box flex="1">
          <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: "16px" }}>
            Follow Us
          </Typography>
          <Stack direction="row" spacing={2}>
            <IconButton href="https://facebook.com" target="_blank" sx={{ color: "#FFFFFF" }}>
              <FacebookIcon />
            </IconButton>
            <IconButton href="https://www.linkedin.com/company/getmyshares-com/" target="_blank" sx={{ color: "#FFFFFF" }}>
              <LinkedInIcon />
            </IconButton>
            <IconButton href="https://instagram.com" target="_blank" sx={{ color: "#FFFFFF" }}>
              <InstagramIcon />
            </IconButton>
          </Stack>
        </Box>
      </Box>

      {/* Footer Bottom */}
      <Box
        sx={{
          marginTop: "40px",
          borderTop: "1px solid #333333",
          paddingTop: "20px",
          textAlign: "center",
          color: "#B5B5B5",
          fontSize: "14px",
        }}
      >
        © {new Date().getFullYear()} GetMyShares. All rights reserved.
      </Box>
    </Box>
  );
};

export default Footer;
